<template>
  <div class="measurement-item-wrapper" :class="[{ right: right }, layout]">
    <div
      v-for="(m, index) in measurements"
      :key="m.key"
      class="measurement-item"
      :class="{ active: activeIndex === index }"
      @click="$emit('click', index)"
    >
      <span class="measurement-name">{{ m.name }}</span>
      <span v-if="useInch" class="measurement-value">{{ m.value | toInch | toFixed }}</span>
      <span v-else class="measurement-value">{{ m.value | toFixed }}</span>
    </div>
  </div>
</template>

<script>
const INCH = 0.393700787;

export default {
  name: 'MeasurementBar',
  props: {
    measurements: Array,
    right: Boolean,
    activeIndex: Number,
    useInch: Boolean,
    layout: String,
  },
  filters: {
    toFixed(value) {
      return parseFloat(value.toFixed(2));
    },
    toInch(value) {
      return value * INCH;
    },
  },
};
</script>

<style lang="scss" scoped>
.measurement-item-wrapper {
  @apply absolute top-0 mt-10;
  &.right {
    @apply right-0;
    .measurement-item {
      @apply items-end;
    }
  }

  &.white {
    @apply flex flex-col justify-around pl-3 py-12 mt-0;
    height: 90%;

    &.right {
      @apply pr-3 pl-0;
    }

    .measurement-item {
      @apply mx-0 my-0 justify-center items-center rounded-full shadow-lg;
      color: #535353;
      width: 108px;
      height: 50px;
      background-color: #f6f6f6ab;

      @screen md {
        width: 149px;
        height: 71px;

        .measurement-name {
          @apply text-sm;
        }

        .measurement-value {
          @apply text-2xl;
        }
      }

      &.active {
        color: #fff;
        background: linear-gradient(to right, #2245ff, #540deb);
      }
    }
  }

  &.dark {
    @apply pl-10 mt-20;
    &.right {
      @apply pr-10 pl-0;
    }
    .measurement-item {
      color: rgb(44, 44, 44);
      .measurement-name {
        @apply font-normal;
      }
    }
  }
}
.measurement-item {
  color: #8c8c8c;
  @apply flex flex-col items-start mb-10 mx-4;
  &.active {
    color: #2245ff;
  }
}

.measurement-name {
  @apply font-bold;
  @apply text-xs;

  @screen md {
    font-size: 26px;
  }
}
.measurement-value {
  @apply text-sm;
  @screen md {
    @apply text-lg;
  }
}
</style>
